import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import type { BreadcrumbSchemaMarkup } from 'bundles/seo/utils/schemaMarkupUtils';
import { getBreadcrumbListMarkupData } from 'bundles/xddp/utils/schema-markup';

type Props = {
  pageContent: any;
};

type SchemaMarkupObj = BreadcrumbSchemaMarkup & {
  '@context': string;
};

class StudentExperiencePageSchemaMarkup extends React.Component<Props> {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  declare context: LegacyContextType<typeof StudentExperiencePageSchemaMarkup.contextTypes>;

  generateSchemaMarkupObj = (): SchemaMarkupObj => {
    const { pageContent } = this.props;
    const { router } = this.context;

    const breadcrumbMarkup = getBreadcrumbListMarkupData(pageContent, {
      pageName: 'Student Experience',
      pathName: router.location.pathname,
    });

    return { '@context': 'http://schema.org', ...breadcrumbMarkup };
  };

  createMarkup = () => {
    const markupObject = this.generateSchemaMarkupObj();

    return {
      __html: `
        <script type="application/ld+json">
          ${JSON.stringify(markupObject)}
        </script>
      `,
    };
  };

  render() {
    const markUp = this.createMarkup();

    return (
      <div className="rc-DegreeGoogleSchemaMarkup">
        {/* eslint-disable react/no-danger */}
        <div dangerouslySetInnerHTML={markUp} />
      </div>
    );
  }
}

export default StudentExperiencePageSchemaMarkup;
